import React, { useState, useRef } from 'react';
import useTranslation from 'next-translate/useTranslation';

import { FaqArrow } from '@/icons/index';

import styles from './CollapsibleItem.module.scss';

const CollapsibleItem = ({
  toggle = '',
  content = '',
  toggleRightText = '',
  defaultStatus = false,
  className = '',
  customToggleHandler,
}) => {
  const { t } = useTranslation();
  const [isShowAll, setIsShowAll] = useState(defaultStatus);
  const block = useRef(null);
  const contentInner = useRef(null);

  const toggleItem = () => {
    block.current.style.setProperty(
      '--answerHeight',
      `${contentInner.current.offsetHeight}px`,
    );
    setIsShowAll(!isShowAll);
  };
  return (
    <div
      className={`${styles.item} ${isShowAll ? styles.open : ''} ${
        className || ''
      }`}
      ref={block}
      itemScope
      itemType='https://schema.org/Thing'
    >
      <div className={styles.toggle} onClick={toggleItem}>
        <div className={styles.label}>{toggle}</div>
        <div className={styles.right}>
          {!!toggleRightText && (
            <span>
              {toggleRightText}₼/ {t('common:month')}
            </span>
          )}
          <div className={styles.icon}>
            <FaqArrow />
          </div>
        </div>
      </div>
      <div className={styles.content}>
        {!!content && typeof content === 'string' ? (
          <div
            className={styles.contentInner}
            ref={contentInner}
            dangerouslySetInnerHTML={{ __html: content }}
          />
        ) : (
          <div
            className={styles.contentInner}
            ref={contentInner}
            onClick={customToggleHandler && toggleItem}
          >
            {content}
          </div>
        )}
      </div>
    </div>
  );
};
export default CollapsibleItem;
